/* common emotion styles used inside the CML editor */
import { css } from '@emotion/react';

export const hoverMenu = () => css`
  background: var(--cds-color-neutral-background-primary);
  border: 1px solid var(--cds-color-interactive-primary-hover);
  border-radius: var(--cds-border-radius-50);
`;
